module.exports = __webpack_public_path__ + "static/media/screenshot-jevelin-startup-clean.3923df80.jpg";